/* eslint-disable react/button-has-type */
/* eslint-disable prettier/prettier */
import { Button, Grid } from '@material-ui/core';
import MediaVideoPlayer from '@orientaction/components/MediaVideoPlayer';
import { FC, useState } from 'react';
import { Choice, ModelPageUserProps } from '@orientaction/types';
import { getIllustrationUrl } from '@orientaction/utils';
import { ReactComponent as Arrow } from '../../../../../Asset/svg/arrow_right.svg';
import { ReactComponent as Check } from '../../../../../Asset/svg/check.svg';
import ItemChoice from '../../ItemChoice';
import ItemCitation from '../../ItemCitation';
import ItemEncyclopedie from '../../ItemEncyclopedie';
import style from '../style';

const Model5: FC<ModelPageUserProps> = ({ page, handleChooseDestion, endGame, handleChooseVariable, endGameVariable, typeGame, nextPageRestitution }) => {
  const classes = style();
  const [selectedChoice, setSelectedChoice] = useState<any>({});

  const chooseChoice = (elemToChoose: Choice) => {
    setSelectedChoice(elemToChoose);
    if (page.typeChoice === 'redirection') {
      window.open(elemToChoose.destinationUrl, '_blank');
    }
  };

  const isSelectedData = (elem: Choice) => {
    return elem.id === selectedChoice.id;
  };

  const goToDestination = () => {
    if (handleChooseDestion && selectedChoice.id && selectedChoice.destination !== undefined) {
      handleChooseDestion(selectedChoice.destination);
      if (selectedChoice.selectedVariable && handleChooseVariable) {
        handleChooseVariable(selectedChoice.selectedVariable)
      }
    }
  };

  const goToDestinationDirect = (idDestination: number, idVariableSelected: number) => {
    if (handleChooseDestion) {
      handleChooseDestion(idDestination);
      if (handleChooseVariable) {
        handleChooseVariable(idVariableSelected)
      }
    }
  };

  return (
    <div className={classes.container} onClick={(e) => e.stopPropagation()}>
      <Grid className={classes.containerGrid} container={true} style={{ height: '100%' }}>
        <Grid
          item={true}
          sm={12}
          className={classes.blockContentParent}
        >
          <div
            className={classes.blockContent}
            style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
          >
            <div className={classes.blockTextLong} style={{ height: '100%', alignItems: 'center' }}>
              {page?.contentForType1 === 'normal' && (
                <div
                  className={`${classes.blockContentTextNormal} editor`}
                  dangerouslySetInnerHTML={{ __html: page?.p1 }}
                />
              )}
              {page?.contentForType1 === 'citation' && (
                <ItemCitation text={page.citationContent1} autor={page.citationAuthor1} />
              )}
              {page?.contentForType1 === 'encyclopedia' && (
                <ItemEncyclopedie text={page.informationEncyclopedia1} />
              )}
            </div>
          </div>
        </Grid>
        <Grid item={true} sm={12} className={classes.blockContentParent}>
          <div className={classes.blockContent}>
            <MediaVideoPlayer
              imageUrl={getIllustrationUrl(page?.illustration)}
              {...page}
              videoUrl={page?.video}
              autoPlayVideo={page?.autoPlayVideo}
              muteVideo={page?.muteVideo}
              imageAlt="page couverture"
              imageClassName={classes.img}
              imageContainerClassName={classes.imgContainer}
            />
          </div>
          <div
            className={classes.blockContent}
            style={{ display: 'flex', flexDirection: 'column', height: '100%', paddingTop: 0 }}
          >
            {page?.choiceTitle && page?.choiceTitle !== '' && (
              <div className={classes.choiceTitle}>{page?.choiceTitle}</div>
            )}
            {page?.typeChoice !== 'end_game' &&
              page?.typeChoice !== 'pursue' &&
              page?.choice?.map((elem: any, index: number) => (
                <div
                  key={elem.id ?? index}
                  style={{ marginBottom: index >= 1 ? 20 : 10 }}
                  onClick={() => chooseChoice(elem)}
                >
                  <ItemChoice
                    id={elem.id}
                    number={index + 1}
                    isSelected={isSelectedData(elem)}
                    title={elem.text}
                  />
                </div>
              ))}
            {page?.typeChoice === 'multiples' && (
              <div className={classes.btnValider}>
                <Button
                  size="small"
                  color="primary"
                  disableRipple={true}
                  className={classes.btn}
                  style={{ background: '#000A8C' }}
                  onClick={goToDestination}
                  endIcon={<Check className={classes.btnicon} />}
                >
                  Valider mon choix
                </Button>
              </div>
            )}
            {page?.typeChoice === 'end_game' && (
              <div
                className={classes.btnEnd}
                style={page?.choiceDisplay === 'carre' ? { justifyContent: 'center' } : {}}
              >
                <div className={classes.choiceEndGame}>
                  {typeGame === 'game' ? 'Le test est terminé' : <>Ceci est la fin du jeu. <br /> Merci.</> }
                </div>
                <Button
                  size="small"
                  color="primary"
                  disableRipple={true}
                  className={classes.btn}
                  style={{ background: '#000A8C', height: 'auto' }}
                  onClick={endGame}
                  endIcon={<Arrow className={classes.btnicon} />}
                >
                  {page.textEndGame}
                </Button>
              </div>
            )}
            {page?.typeChoice === 'pursue' && (
              <div className={classes.btnPursue}>
                <Button
                  size="small"
                  color="primary"
                  disableRipple={true}
                  className={classes.btnPursueInside}
                  style={{ background: '#000A8C' }}
                  onClick={() => goToDestinationDirect(page?.choice?.[0]?.destination ?? 0, page?.choice?.[0]?.selectedVariable ?? 0)}
                  endIcon={<Arrow className={classes.btnicon} />}
                >
                  <span dangerouslySetInnerHTML={{ __html: page?.choice?.[0]?.text || '' }} />
                </Button>
              </div>
            )}
            {page?.isVariable && !page?.isEndVariable && (
              <div className={classes.btnPursue}>
                <Button
                  size="small"
                  color="primary"
                  disableRipple={true}
                  className={classes.btnPursueInside}
                  style={{ background: '#000A8C' }}
                  onClick={nextPageRestitution}
                  endIcon={<Arrow className={classes.btnicon} />}
                >
                  Suivant
                </Button>
              </div>
            )}
            {page?.isVariable && page?.isEndVariable && (
              <div className={classes.btnPursue} style={{ width: '100%', paddingLeft: '0px', paddingRight: '0px' }}>
                <Button
                  size="small"
                  color="primary"
                  disableRipple={true}
                  className={classes.btnPursueInside}
                  style={{ background: '#000A8C', padding: 20, fontSize: 16, width: '100%' }}
                  onClick={endGameVariable}
                  endIcon={<Arrow className={classes.btnicon} />}
                >
                  Retour à la liste des ressources
                </Button>
              </div>
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Model5;
